import { put, select, takeLatest, all } from 'redux-saga/effects';
import { notify } from '@mrlannigan/reapop';
import { sagaError } from 'helpers/handleGenericSagaError';

import apiAuthCall from 'helpers/apiAuthCall';
import {
    actions,
    setScoreboardInformation,
} from './duck';
import {
    getMonitorGraphQLEndpoint,
} from './selectors';


/**
 * @export
 * @param {*} api
 * @param {{ type: String, payload: String[] }} action
 */
export function* fetchScoreboardInformation(api, action) {
    const notificationId = 'fetchScoreboardInformation';

    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'post',
                url: yield select(getMonitorGraphQLEndpoint),
                data: {
                    query: `query  {
                        scoreboard {
                            campaignEngineOpportunityTotalCount
                            uniqueOpportunityTrackablesCount
                            activationPercentage
                            totalProtectedBudget
                        }
                        
                        rules {
                            name
                            createdAt
                            scoreboard {
                                monitorTotalCount
                                activationPercentage
                                subscriptionCount
                                uniqueUserSubscriptionCount
                                monitorsWithNoSubscriptionCount
                                uniqueOpportunityTrackablesCount
                                totalProtectedBudget
                                last30: auditStatus(last:30) {
                                    status
                                    count
                                }
                                totalAlertCount(last:30)
                            }
                        }
                    }`,
                }
            }
        );

        yield put(setScoreboardInformation(result.data.data));
    } catch (err) {
        yield put(notify({
            id: notificationId,
            ...sagaError(err)
        }));
    }
}

export default function* entitySaga({ api }) {
    yield all([
        takeLatest(actions.REQUEST_SCOREBOARD_INFORMATION, fetchScoreboardInformation, api),
    ]);
}



// WEBPACK FOOTER //
// ./src/services/smartguard/saga.js